import React, {useEffect} from 'react';

const Page = (): JSX.Element => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
  }, []);

  return (
    <iframe
      title="Stryd Privacy Policy"
      src="https://www.iubenda.com/privacy-policy/137798/legal"
      style={{
        position: 'relative',
        width: '100%',
        height: '100vh',
        border: 'none',
        scrollBehavior: 'auto',
      }}
    />
  );
};

export default Page;
